import styled from 'styled-components';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import { purple, grey } from '@material-ui/core/colors';

export const BackButtonWrapper = styled.span`
  display: flex;
  align-items: center;
  cursor: pointer;
  line-height: 1;
`;

export const HomeButtonWrapper = styled.a`
  display: flex;
  align-items: center;
  cursor: pointer;
  line-height: 1;
  // color: white;
  color: ${(props) => (props.isDark ? 'white' : grey[800])};
  font-size: 2.3em;
`;

export const PurpleSwitch = withStyles({
  switchBase: {
    color: purple[300],
    '&$checked': {
      color: purple[500],
    },
    '&$checked + $track': {
      backgroundColor: purple[500],
    },
  },
  checked: {},
  track: {
    backgroundColor: grey[400],
  },
})(Switch);

export const FormControl = withStyles({
  label: {
    textTransform: 'uppercase',
    fontSize: '0.6em',
  },
})(FormControlLabel);

export const useStyles = makeStyles({
  backButton: {
    fontSize: '0.8rem',
    padding: '0',
    margin: '0',
  },

  userIcon: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '1.6rem',
  },
});
